import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faRefresh } from "@fortawesome/free-solid-svg-icons";
import { Popover, PopoverAnchor, PopoverContent, RangeInput } from ".";
import { isEmptyObject } from "../helpers";
import classnames from "classnames";
import { INPUT_LIMITS } from "../input-limits";

const CSSFilters = ({ value, onChange, label = "", className }) => {
  const [isOpen, setIsOpen] = useState(false);

  const resetState = () => {
    onChange({});
  };

  if (value === undefined || value === null) {
    value = {};
  }

  const valueExists = () => {
    if (value === undefined || value === null || isEmptyObject(value)) {
      return false;
    } else {
      return true;
    }
  };

  const classes = classnames(
    "grigora-filter-input select-none  text-grigora-base  flex w-full mb-2 gap-4 items-center",
    className,
  );

  return (
    <div className={classes}>
      {" "}
      {label && (
        <div className="grigora-filter-input__label flex flex-1 ">{label}</div>
      )}
      <div className="flex items-center">
        {valueExists() ? (
          <>
            <div onClick={resetState} className="mr-2 cursor-pointer">
              <FontAwesomeIcon icon={faRefresh} size="sm" />
            </div>
          </>
        ) : null}
        <Popover placement="left">
          <PopoverAnchor open={isOpen} onOpenChange={setIsOpen}>
            <div className="px-2 py-1 bg-editor-dark-main cursor-pointer">
              <FontAwesomeIcon icon={faPen} size="sm" />
            </div>
          </PopoverAnchor>
          <PopoverContent>
            <div className="p-3 w-30 z-10 bg-editor-dark-main">
              <RangeInput
                value={value.blur}
                onChange={(val) => {
                  onChange({ ...value, blur: val });
                }}
                // min={0}
                // max={10}
                // step={0.1}
                min={INPUT_LIMITS["css-filters-blur"].min}
                max={INPUT_LIMITS["css-filters-blur"].max}
                step={INPUT_LIMITS["css-filters-blur"].step}
                label={"Blur"}
              />
              <RangeInput
                value={value.brightness}
                onChange={(val) => {
                  onChange({ ...value, brightness: val });
                }}
                // min={0}
                // max={200}
                // step={1}
                min={INPUT_LIMITS["css-filters-brightness"].min}
                max={INPUT_LIMITS["css-filters-brightness"].max}
                step={INPUT_LIMITS["css-filters-brightness"].step}
                label={"Brightness"}
              />
              <RangeInput
                value={value.contrast}
                onChange={(val) => {
                  onChange({ ...value, contrast: val });
                }}
                // min={0}
                // max={200}
                // step={1}
                min={INPUT_LIMITS["css-filters-contrast"].min}
                max={INPUT_LIMITS["css-filters-contrast"].max}
                step={INPUT_LIMITS["css-filters-contrast"].step}
                label={"Contrast"}
              />
              <RangeInput
                value={value.saturation}
                onChange={(val) => {
                  onChange({ ...value, saturation: val });
                }}
                // min={0}
                // max={200}
                // step={1}
                min={INPUT_LIMITS["css-filters-saturation"].min}
                max={INPUT_LIMITS["css-filters-saturation"].max}
                step={INPUT_LIMITS["css-filters-saturation"].step}
                label={"Saturation"}
              />
              <RangeInput
                value={value.hue}
                onChange={(val) => {
                  onChange({ ...value, hue: val });
                }}
                // min={0}
                // max={360}
                // step={1}
                min={INPUT_LIMITS["css-filters-hue"].min}
                max={INPUT_LIMITS["css-filters-hue"].max}
                step={INPUT_LIMITS["css-filters-hue"].step}
                label={"Hue"}
              />
            </div>
          </PopoverContent>
        </Popover>
      </div>
    </div>
  );
};

export default CSSFilters;
